<div class="not-found-content">
    <!-- <div style="margin-top: 3rem;" class="center-text">
        <fa-icon [icon]="faBan" class="working-progress"></fa-icon>
        <h2 class="text-gray" style="font-size: 3.8rem;">Data releases coming soon for this region.</h2>
        <h4 class="text-gray" style="font-size: 3rem;">Please try another one.</h4>
    </div> -->
</div>
